"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var uniq = require('lodash/uniq');

var flattenDeep = require('lodash/flattenDeep');

function PrintJobColorsUsed(_ref) {
  var printJob = _ref.printJob,
      variant = _ref.variant;
  var method = variant === 'letterpress' ? 'letterpressColorsUsed' : 'colorsUsed';
  var colors_used = uniq(flattenDeep(printJob.products.filter(function (product) {
    return product[method];
  }).map(function (product) {
    return product[method]();
  })));
  return /*#__PURE__*/React.createElement("span", null, "Colors Used: ", colors_used.join(', ').toUpperCase());
}

PrintJobColorsUsed.propTypes = {
  variant: PropTypes.oneOf(['digital', 'letterpress']),
  printJob: PropTypes.shape({
    products: PropTypes.array.isRequired
  }).isRequired
};
module.exports = PrintJobColorsUsed;